import React, { useContext, useEffect, useState } from "react";
import { Box, Typography, Button, ButtonBase, Card } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ordersPathTo } from '../utils/Api';
import OrderCard from "./OrderCard";
import { UserContext } from "../contexts/UserContext";

/* Icons */
import { ArrowBackRounded } from '@mui/icons-material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import EditIcon from '@mui/icons-material/Edit';
import { layoutCardRadius, layoutIconButtonRadius } from '../theme/colors';

const MyOrders = () => {
  const [orders, setOrders] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { currentUser } = useContext(UserContext);
  const navigate = useNavigate();
  const defaultAddress = currentUser?.default_address;

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const result = await ordersPathTo.list({ with_logo: true, with_items: true });
        setOrders(result.data.orders || []);
        setIsLoading(false);
      } catch (error) {
        console.error('Erro ao carregar pedidos:', error);
        setIsLoading(false);
      }
    };

    fetchOrders();
  }, []);

  const formatAddress = (address) => {
    if (!address) return 'Adicionar endereço de entrega';

    return [
      [address.logradouro, address.numero].filter(Boolean).join(', ')
    ].filter(Boolean).join(', ');
  };

  const latestFinalizedOrder = orders.find((order) => (
    order.status === 'done' &&
    order.provider?.published === true
  )) || null;

  const sortedOrders = [...orders].sort((a, b) => (b.id || 0) - (a.id || 0));

  useEffect(() => {
    if (isLoading) {
      return;
    }

    if (latestFinalizedOrder) {
      localStorage.setItem('latestOrder', JSON.stringify(latestFinalizedOrder));
      localStorage.setItem('latestOrders', JSON.stringify([latestFinalizedOrder]));
    } else {
      localStorage.removeItem('latestOrder');
      localStorage.removeItem('latestOrders');
    }
  }, [isLoading, latestFinalizedOrder]);

  const renderEmptyMessage = (message) => (
    <Card sx={{ display: 'flex', padding: '24px', alignItems: 'center', alignSelf: 'stretch', bgcolor: 'surface.card', borderRadius: layoutCardRadius }}>
      <Typography sx={{ fontFamily: 'Nunito', fontSize: '14px', fontWeight: 400, lineHeight: '24px', color: '#546E7A' }}>
        {message}
      </Typography>
    </Card>
  );

  const renderOrderList = () => {
    if (isLoading) {
      return renderEmptyMessage('Carregando...');
    }

    if (sortedOrders.length === 0) {
      return renderEmptyMessage('Você ainda não tem pedidos');
    }

    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, alignSelf: 'stretch', width: '100%' }}>
        {sortedOrders.map((order) => (
          <OrderCard
            key={order.id}
            order={order}
            handleCardClick={() => navigate('/orders/' + order.id)}
          />
        ))}
      </Box>
    );
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 3 }}>
      {/* Voltar e Título */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, alignSelf: 'stretch', position: 'relative' }}>
        <Button data-no-shadow="true" onClick={() => window.history.back()} sx={{ color: 'text.primary', borderRadius: layoutIconButtonRadius }}>
          <ArrowBackRounded />
        </Button>

        {/* Título */}
        <Typography variant="pageTitle" sx={{ width: 'auto', transform: 'translateX(-50%)', position: 'absolute', left: '50%' }}>Pedidos</Typography>
      </Box>

      {/* Endereço de Entrega */}
      <Card
        sx={{ display: 'flex', padding: '24px', flexDirection: 'column', alignItems: 'flex-start', gap: '7px', alignSelf: 'stretch', bgcolor: 'surface.card', borderRadius: layoutCardRadius, textAlign: 'left' }}
      >
        <Typography sx={{ fontFamily: 'Nunito', fontSize: '14px', fontWeight: 400, lineHeight: '24px' }}>
          Entregar em:
        </Typography>

        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1, alignSelf: 'stretch' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <LocationOnIcon sx={{ color: '#F8963E' }} />
            <Typography sx={{ fontFamily: 'Nunito', fontSize: '14px', fontWeight: 600, lineHeight: '20px', color: '#263238' }}>
              {formatAddress(defaultAddress)}
            </Typography>
          </Box>

          <Typography sx={{ fontFamily: 'Nunito', fontSize: '14px', fontWeight: 700, lineHeight: '20px', color: '#F8963E', cursor: 'pointer' }}>
            {/* Botão para Mudar Img */}
            <ButtonBase
              onClick={() => navigate('/address?from=orders')}
              variant="outlined"
              component="label"
              sx={{ width: '32px', height: '32px', borderRadius: '50%', bgcolor: '#263238', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <EditIcon sx={{ width: '16px', height: '16px' }} />
            </ButtonBase>
          </Typography>
        </Box>
      </Card>

      {renderOrderList()}
    </Box>
  );
};

export default MyOrders;
